export default "__VITE_ASSET__DtCIe0tP__"